module.exports = __webpack_public_path__ + "img/thumb_06.163e521e.jpg";